import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./matchDetail.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./matchDetail.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchDetail.vue?vue&type=script&lang=js&
// module id = Cq2+
// module chunks = 0